// Mobile PDP "See Purchasing Options" button (.purchase-options-button)
// - Click: smooth-scroll the page down to the variant/purchase options.
// - The button hides as soon as the page scrolls away from the top, so it
//   never overlaps the size selector / add-to-bag once you're in the options.

const SCROLL_HIDE_THRESHOLD = 8; // px from top before the button hides
const SCROLL_TARGET_GAP = 12; // breathing room above the options

export function initPdpPurchaseOptions() {
  const button = document.querySelector(
    ".template-product .purchase-options-button",
  );
  if (!button) return;

  const scope = button.closest(".template-product") || document;

  function getScrollTarget() {
    // First variant selector (Select a Size / Select a Variation); fall back to
    // the whole product form for products with no selectable options.
    return (
      scope.querySelector(".product-form__item") ||
      scope.querySelector(".product-form")
    );
  }

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  button.addEventListener("click", () => {
    const target = getScrollTarget();
    if (!target) return;

    const header = document.querySelector(".site-header");
    const headerHeight = header ? header.offsetHeight : 0;
    const top =
      target.getBoundingClientRect().top +
      getScrollTop() -
      headerHeight -
      SCROLL_TARGET_GAP;

    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  });

  let ticking = false;
  function updateVisibility() {
    const scrolledAway = getScrollTop() > SCROLL_HIDE_THRESHOLD;
    button.classList.toggle("purchase-options-button--hidden", scrolledAway);
    ticking = false;
  }

  updateVisibility();
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    },
    { passive: true },
  );
}
